<pdq-card variant="popover" color="white">
  <div class="container">
    <div class="header">
      <pdq-heading element="h3" capitalized="true">Connect Order Protection</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>

    <div class="content">
      @if (loading) {
        <div class="loading">
          <pdq-spinner></pdq-spinner>
        </div>
      } @else if (showIntro) {
        <p class="body-14-regular">Connecting Order Protection takes three steps:</p>
        <ol class="steps body-14-regular">
          <li>
            @if (storeDomain) {
              We request access to your store in Order Protection (<strong>{{ storeDomain }}</strong
              >).
            } @else {
              We request access to your store in Order Protection.
            }
          </li>
          <li>You approve that request in your Order Protection dashboard.</li>
          <li>We install the PDQ app on your Order Protection account and finish the connection.</li>
        </ol>
        <p class="hint body-12-regular">If you've already granted access, we'll skip straight to the install step.</p>
      } @else if (showApprove) {
        @if (isApproved) {
          <p class="body-14-regular">
            You've already granted PDQ access
            @if (storeDomain) {
              <span>
                to <strong>{{ storeDomain }}</strong></span
              >
            }
            — no approval needed. One step left: install the PDQ app on your Order Protection account to finish.
          </p>
        } @else {
          <p class="body-14-regular">We've sent an access request. To continue, approve it in Order Protection:</p>
          <ol class="steps body-14-regular">
            <li>Open your dashboard → <strong>Settings → Collaborators</strong>.</li>
            <li>
              @if (collaborationCode) {
                Approve the request from <strong>Pretty Damn Quick</strong> (code
                <strong>{{ collaborationCode }}</strong
                >).
              } @else {
                Approve the request from <strong>Pretty Damn Quick</strong>.
              }
            </li>
          </ol>
          <p class="body-14-regular">
            Once you approve, we'll install the PDQ app on your Order Protection account and set up the connection.
          </p>
        }

        <div class="permissions">
          <p class="body-14-regular"><strong>Once installed, PDQ will be able to:</strong></p>
          <ul class="body-14-regular">
            <li>View your store, orders, products, and protection claims</li>
            <li>Read protection analytics</li>
            <li>View and manage protection policies and shipping-protection pricing</li>
            <li>Create and manage A/B tests</li>
            <li>Configure the protection widget (cart, checkout, and info modal)</li>
            <li>Manage the PDQ integration settings</li>
          </ul>
        </div>

        @if (!isApproved) {
          <pdq-button
            variant="secondary"
            label="Open Order Protection"
            [disabled]="submitting"
            (onClick)="openDashboard()"></pdq-button>
        }

        <p class="hint body-12-regular">
          Already installed the PDQ app on Order Protection? This won't install it again — we'll just link the existing
          app and finish the connection.
        </p>

        @if (notApprovedYet) {
          <p class="hint body-12-regular warn">
            We don't see an approval yet. Approve it in Order Protection, then try again.
          </p>
        }
      } @else if (showConnected) {
        <p class="body-14-regular">
          Order Protection is connected. The PDQ app is installed on your Order Protection account and ready to
          configure.
        </p>
      }

      @if (errorMessage) {
        <p class="hint body-12-regular warn">{{ errorMessage }}</p>
      }
    </div>

    <pdq-divider></pdq-divider>
    <footer>
      @if (showConnected) {
        <pdq-button variant="primary" label="Done" (onClick)="close()"></pdq-button>
      } @else {
        <pdq-button variant="tertiary" label="Cancel" [disabled]="submitting" (onClick)="close()"></pdq-button>
        @if (showApprove) {
          <pdq-button
            variant="primary"
            label="Install & finish"
            [loading]="submitting"
            [disabled]="submitting"
            (onClick)="finalize()"></pdq-button>
        } @else {
          <pdq-button
            variant="primary"
            label="Request access"
            [loading]="submitting"
            [disabled]="submitting || loading"
            (onClick)="connect()"></pdq-button>
        }
      }
    </footer>
  </div>
</pdq-card>
